'use strict';

var chr = require('../../common/var/chr');

function incrementString(current, amount) {
  return chr(current.charCodeAt(0) + amount);
}

module.exports = incrementString;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/range/internal/incrementString.js
// module id = 416
// module chunks = 1